import React, {Component} from "react";
import {ExtensionAdminService} from "../../../../service/operation/extensionAdmin/ExtensionAdminService";
import {CommonService} from "../../../../service/commons/CommonService";
import InsertExtensionAdmin from "./InsertExtensionAdminView";
import {Growl} from "primereact/growl";

export default class InsertExtensionAdminContainer extends Component {
    constructor(props) {
        super(props);
        this.extensionAdminService = new ExtensionAdminService();
        this.commonService = new CommonService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.getLoanAndGuarantee = this.getLoanAndGuarantee.bind(this);
        this.saveDataExtensionAdmin = this.saveDataExtensionAdmin.bind(this);
        this.insertExtensionAdmin = this.insertExtensionAdmin.bind(this);

        this.state = {
            isLoading: true,
            returnPath: this.props.location.state.returnPath,
            loanId: this.props.location.state.loanId,
            loan: [],
            guarantee: [],
            maturity: '',
            rate: '',
            surcharge: '0',
        };

        this.getLoanAndGuarantee()
    }

    getLoanAndGuarantee() {
        return this.commonService.getLoanAndGuarantee(this.state.loanId).then(
            res => {
                this.setState({
                    isLoading: false,
                    loan: res[0],
                    guarantee: res[1],
                    extension: res[2]
                });
            }
        );
    }

    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    saveDataExtensionAdmin(event) {
        const {name, value} = event.target;
        this.setState({[name]: value,})
    }

    getMessageError() {
        let msgError = '';
        let fields = [];

        if (this.state.rate === undefined || this.state.rate === "") {
            fields.push("Tasa");
        }

        if (this.state.surcharge === undefined || this.state.surcharge === "") {
            fields.push("SobreTasa");
        }

        if (this.state.maturity === undefined || this.state.maturity === "" || this.state.maturity === "0") {
            fields.push("Plazo");
        }


        if (fields.length > 0) {
            msgError = "Favor de revisar los siguientes campos: ";

            fields.map(field => {
                msgError = msgError + field + ', ';
                return '';
            });
        }

        return msgError;
    }

    insertExtensionAdmin() {
        let message = this.getMessageError();

        if (message !== '') {
            this.growl.show({severity: 'error', summary: 'Error.', detail: message});
            return;
        }

        this.loading(true);
        this.extensionAdminService.insertExtensionAdmin(
            this.state.loan[0].idFolioPrest,
            this.state.maturity,
            this.state.loan[0].statusPV,
            this.state.rate,
            this.state.surcharge
        ).then(
            resp => {
                if (resp.message === 'Success') {
                    let message = {
                        severity: 'success',
                        summary: 'Éxito',
                        detail: 'La prórroga se insertó correctamente',
                    };
                    this.handleReturnButton(message);
                } else if (resp.error !== '') {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: resp.error});
                }
                this.loading(false);
            }
        );
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <InsertExtensionAdmin
            messagesGrowl={messagesGrowl}
            isLoading={this.state.isLoading}
            handleReturnButton={this.handleReturnButton}
            loan={this.state.loan}
            guarantee={this.state.guarantee}
            insertExtensionAdmin={this.insertExtensionAdmin}
            saveDataExtensionAdmin={this.saveDataExtensionAdmin}
            maturity={this.state.maturity}
            rate={this.state.rate}
            surcharge={this.state.surcharge}
        />
    }
};